import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeTab: {},
  equipment: {
    userEinId: null,
    equipmentIdentificationNumberFreeText: null,
  },
  options: {
    scrapSourceList: [],
    providedByList: [],
    vehicleCategoryList: [],
    scrapTypeList: [],
    quantityUnitList: [],
    materialTypeList: [],
  },
  categoryOptions: [],
}

const jobsReducer = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    setJobActiveTab: (state, action) => {
      state.activeTab = { ...state.activeTab, ...action.payload }
    },
    setEquipmentData: (state, action) => {
      state.equipment = { ...state.equipment, ...action.payload }
    },
    setOptionsList: (state, action) => {
      state.options = { ...state.options, ...action.payload }
    },
    setCategoryOptions: (state, action) => {
      state.categoryOptions = action.payload
    },
  },
})

export const {
  setJobActiveTab,
  setJobDisplayUnit,
  setEquipmentData,
  setOptionsList,
  setCategoryOptions,
} = jobsReducer.actions

export default jobsReducer.reducer
